
import { Component, Mixins, Prop } from "vue-property-decorator";

@Component
export default class AlertIndicationMixin extends Mixins() {
  @Prop()
  isAlert: boolean;

  get alertStyles(): any {
    return {
      color: this.isAlert ? this.alertColor : null,
      backgroundColor: this.isAlert ? this.alertBackgroundColor : null,
    };
  }

  get alertColor(): string {
    return this.$configuration.style.alertIndication.color;
  }

  get alertBackgroundColor(): string {
    return this.$configuration.style.alertIndication.backgroundColor;
  }
}
